import React from 'react';

export default function ContentFooter({ children, className, style }) {
  return (
    <div
      className={className}
      style={{
        zIndex: 1,
        display: 'flex',
        //backgroundColor: 'orange',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
